// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmModal_modal__iNFj2","footer":"ConfirmModal_footer__XZvbB"};